/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { flare } from '@flareapp/js';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { flareConfig } from './flare.config';
import { startGALogger } from './app/@core/utils/ga-logger';
import { cleanupForeignSessionCookies, warnIfCookieHeaderTooLarge } from './app/@core/utils/cookie-cleanup';

cleanupForeignSessionCookies();
warnIfCookieHeaderTooLarge();

if (environment.production) {
  enableProdMode();
} else {
  startGALogger();
}

const isLocalhost: boolean =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '0.0.0.0');

if (flareConfig.key && !isLocalhost) {
  flare.light(flareConfig.key);
  flare.configure({
    stage: environment.production ? 'production' : 'development',
  });
  flare.addContextGroup('app', { name: 'pwa' });
  flare.addContextGroup('client', {
    name: environment.appname,
    subdomain: environment.subdomainName,
  });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
